<div class="search-container-details">
    <div class="tab-title-icon">
        <cll-icon class="tab-icon" type="outlined">attachment</cll-icon>
        <span class="detail-table-title">Documents</span>
    </div>
    <div>
        <button
            cll-icon-button
            cllSuffix>
            <cll-icon>add</cll-icon>
        </button>
    </div>
</div>

<div class="tabs-table-container">
    <table class="cll-table">
        <thead>
        <tr>
            <th><input type="checkbox" /></th>
            <th>Name</th>
            <th>Type</th>
            <th>Tags</th>
            <th>Uploaded</th>
            <th>Notes</th>
            <th></th>
        </tr>
        </thead>
        <tbody>
        <tr>
            <td><input type="checkbox" /></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td class="align-right">
                <button cll-icon-button
                        [cllMenuTriggerFor]="menu"
                        (click)="$event.stopPropagation()">
                    <cll-icon>more_vert</cll-icon>
                </button>

                <ng-template #menu>
                    <cll-menu>
                        <a cllMenuItem>
                            <cll-icon>open_in_new</cll-icon>
                            View Document
                        </a>
                    </cll-menu>
                </ng-template>
            </td>
        </tr>
        </tbody>
    </table>
</div>
